function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.86 392.86",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M21.917,173.964v86.303h93.802v-86.303c0-25.859-21.01-46.933-46.933-46.933 S21.917,148.105,21.917,173.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M40.406,282.053v88.695h17.519v-52.234c0-6.012,4.848-10.925,10.925-10.925 s10.925,4.848,10.925,10.925v52.234h17.519v-88.695H40.406z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M68.85,21.786c-15.063,0-27.281,12.283-27.281,27.281S53.852,76.347,68.85,76.347 s27.281-12.283,27.281-27.281S83.913,21.786,68.85,21.786z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#56ACE0"
    },
    points: "152.244,49.067 370.878,49.067 370.878,21.786 152.244,21.786 152.244,21.786 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.896,
    y: 70.853,
    style: {
      fill: "#FFC10D"
    },
    width: 179.329,
    height: 179.459
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M381.803,0H152.309c-6.012,0-10.925,4.848-10.925,10.925s4.848,10.925,10.925,10.925h218.505v27.281 H152.309c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925H351.29V250.44H171.896 c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925h79.386l11.507,49.584H155.541 c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925h112.356l9.438,40.663 c1.422,5.883,7.24,9.503,13.059,8.21c5.883-1.422,9.503-7.176,8.21-13.059l-24.889-107.184h88.501 c6.012,0,10.925-4.848,10.925-10.925V70.853h8.663c6.012,0,10.925-4.848,10.925-10.925V10.861C392.664,4.848,387.816,0,381.803,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M68.85,105.244c-37.883,0-68.719,30.836-68.719,68.719v97.228c0,6.012,4.848,10.925,10.925,10.925 h7.499v99.62c0,6.012,4.848,10.925,10.925,10.925h78.739c6.012,0,10.925-4.848,10.925-10.925v-99.685h7.499 c6.012,0,10.925-4.848,10.925-10.925v-97.164C137.505,136.081,106.668,105.244,68.85,105.244z M97.23,370.747H79.711v-52.234 c0-6.012-4.848-10.925-10.925-10.925c-6.077,0-10.925,4.848-10.925,10.925v52.234H40.406v-88.695h56.889v88.695H97.23z  M115.719,260.267H21.917v-86.303c0-25.859,21.01-46.933,46.933-46.933s46.933,21.01,46.933,46.933v86.303H115.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M68.85,98.198c27.022,0,49.131-22.044,49.131-49.131S95.872,0,68.85,0S19.783,22.044,19.783,49.131 S41.763,98.198,68.85,98.198z M68.85,21.786c15.063,0,27.281,12.283,27.281,27.281S83.848,76.347,68.85,76.347 S41.569,64.129,41.569,49.131S53.723,21.786,68.85,21.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M202.862,179.588l28.444-20.945l27.41,32.129c5.495,5.495,12.024,4.784,16.097,0.517l48.808-50.295 c4.202-4.331,4.073-11.184-0.259-15.451c-4.331-4.202-11.184-4.073-15.451,0.259l-40.404,41.697l-26.311-30.707 c-3.685-4.331-10.15-5.107-14.739-1.681l-36.655,26.893c-4.848,3.556-5.883,10.343-2.327,15.192 C191.161,182.044,198.014,183.143,202.862,179.588z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/Demo.94a1e794.svg";
export { ForwardRef as ReactComponent };